/*
 *		Copyright (c) 2011-2019 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .directive('accNotarizedFilesActions', ['template', function (template) {
        return {
            scope: {
                selectedRevisions: '=',
                resetSelection: '&'
            },
            templateUrl: template('nodes/_notarized_files_actions'),
            controller: ['$scope', 'nodeDownload', 'purgeSelectedRevisions', 'operationComplete',
                function ($scope, nodeDownload, purgeSelectedRevisions, operationComplete) {
                    $scope.download = function () {
                        $scope.selectedRevisions.forEach(function (revision) {
                            nodeDownload(revision);
                        });
                    };

                    $scope.canPermanentlyDelete = function () {
                        return $scope.selectedRevisions.every(function (revision) {
                            return revision['permissions']['can_be_purged'];
                        });
                    };

                    $scope.hasNotarizationCertificate = function (notarization) {
                        return notarization && notarization['status'] === 'successful';
                    };

                    $scope.permanentlyDelete = function () {
                        var
                            items = $scope.selectedRevisions.map(function (revision) {
                                return Object.defineProperties({
                                    uuid: revision.uuid,
                                    revision: revision.revision
                                }, {
                                    // In order to be compatible with signed_notarized_files_delete_warning
                                    // we need to implement 2 methods,
                                    // which makes our revision looks like a node
                                    latest_notarized_revision: {
                                        get: function () {
                                            return revision.notarization && revision.notarization.status === 'successful' ? { notarization: revision.notarization } : null;
                                        }
                                    },
                                    has_esignature: {
                                        value: revision.has_esignature
                                    }
                                });
                            });

                        purgeSelectedRevisions(items).then(function () {
                            $scope.$emit('reload.dataTable');

                            operationComplete('Deleted');
                        });
                    };
                }
            ]
        };
    }]);
